import React, { useState } from "react";
// import "./FindMember.css";
// import "../../components/CommonStyle.css";
// import "../../Styles/FindMember.css";
import "../../Styles/CommonStyles.scss";
// import CalendarImg from "../../Images/calendar.png";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import InputField from "../StyledComp/InputField";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// import Select from "react-select";
// import {
//   FormWrapper,
//   FormInput,
//   FormLabel,
//   FormInputRow,
//   FormMessage,
//   Button,
//   FormTitle,
// } from "../StyledComp/StyledComp";
// import { Label } from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  // searchMemberApiSlice,
  updateSearchBody,
} from "../../store/searchMemberApiSlice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  updateSearchParamFlags,
  // resetSearchParamFlags,
} from "../../store/hasSearchParamFlags";

import dayjs, { Dayjs } from "dayjs";
interface MemberCode {
  [key: string]: any;
}
interface Memberype {
  [key: string]: any;
}
interface IProps {
  MemberCode: MemberCode[];
  MemberType: Memberype[];
}

const FMPersonalInfo: React.FC<IProps> = (props) => {
  console.log("FM personal info");
  const dispatch = useDispatch();
  const MemberCodes = props.MemberCode;
  const MemberTypes = props.MemberType;
  const [adminDateFrom, setAdminDateFrom] = useState<Dayjs | null>(dayjs(null));
  const [adminDateTo, setAdminDateTo] = useState<Dayjs | null>(dayjs(null));
  const [lastPaidFrom, setLastPaidFrom] = useState<Dayjs | null>(dayjs(null));
  const [lastPaidTo, setLastPaidTo] = useState<Dayjs | null>(dayjs(null));
  const [CertEndsAfter, setCertEndsAfter] = useState<Dayjs | null>(dayjs(null));
  const [CertEndsBefore, setCertEndsBefore] = useState<Dayjs | null>(
    dayjs(null)
  );
  const [dateOfBirthFrom, setDateOfBirthFrom] = useState<Dayjs | null>(
    dayjs(null)
  );
  const [dateOfBirthTo, setDateOfBirthTo] = useState<Dayjs | null>(dayjs(null));
  // const [lastUpdateFrom, setLastUpdateFrom] = useState<Dayjs | null>(
  //   dayjs(null)
  // );
  // const [lastUpdateTo, setLastUpdateTo] = useState<Dayjs | null>(dayjs(null));

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("updateInput");
    // console.log(event.target.name, " .. ", event.target.value);
    dispatch(
      updateSearchBody({ key: event.target.name, value: event.target.value })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };
  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log("updateSelectBox", event.target.name, event.target.value);
    dispatch(
      updateSearchBody({ key: event.target.name, value: event.target.value })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const setConsolidatedDate = (passedDate: Dayjs, type: string) => {
    console.log("setConsolidatedDate", passedDate, type);
    // console.log(new Date(passedDate))
    // console.log(new Date(passedDate).toISOString())
    dispatch(
      updateSearchBody({
        key: type,
        value: passedDate.format("YYYY-MM-DD"),
      })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  return (
    <div className="section-box">
      <h3 className="section-heading">Personal Information</h3>
      <div className="form-wrapper">
        <div className="input-field-div-wrapper" style={{ width: "44%" }}>
          <input
            className="input-field-div-small"
            placeholder=""
            id="MemberId"
            name="MemberId"
            autoComplete="off"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="MemberId">
            BarID
          </label>
        </div>

        {/* <div className="input-field-div-wrapper">
          <select
            className="dropdown-control-large-insidetextfield"
            onChange={updateSelectBox}
            id="MemberTypeId"
            name="MemberTypeId"
          >
            <option value={""}> Select Member Type</option>
            {MemberTypes?.map((MemberType: any) => (
              <option key={MemberType.Id} value={MemberType.Id}>
                {MemberType.MemberType}
              </option>
            ))}
            ;
          </select>
        </div> */}

        <div className="input-field-div-wrapper" style={{ width: "44%" }}>
          {/* <div className="selectfield-label">Member Code</div> */}
          <select
            className="dropdown-control-large-insidetextfield"
            onChange={updateSelectBox}
            id="MemberCodeId"
            name="MemberCodeId"
          >
            <option value={""}> Select Member Code </option>
            {MemberCodes?.map((MemberCode: any) =>
              MemberCode.Status ? (
                <option key={MemberCode.Id} value={MemberCode.Id}>
                  {MemberCode.MemberCode} {" - "} {MemberCode.Description}
                </option>
              ) : null
            )}
            ;
          </select>
        </div>

        <div className="input-field-div-wrapper" style={{ width: "44%" }}>
          <input
            className="input-field-div-small"
            id="FirstName"
            placeholder=""
            name="FirstName"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="FirstName">
            First Name
          </label>
        </div>
        <div className="input-field-div-wrapper" style={{ width: "44%" }}>
          {/* <Label>Last Name</Label> */}
          <input
            className="input-field-div-small"
            id="LastName"
            name="LastName"
            placeholder=""
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="LastName">
            Last Name
          </label>
        </div>

        {/* <div className="input-field-div-wrapper">
         
          <select
            className="dropdown-control-large-insidetextfield"
            id="Gender"
            name="Gender"
            onChange={updateSelectBox}
          >
            <option value=""> Select Gender </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Unspecified">Unspecified</option>
          </select>
        </div> */}

        <div className="datepicker-group" style={{ width: "100%" }}>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="CertificationEndsOn (AFTER)"
                  value={lastPaidFrom}
                  onChange={(date) => {
                    date &&
                      setConsolidatedDate(date, "FromCertificationEndsOn");
                    date && setCertEndsAfter(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="CertificationEndsOn (Before)"
                  value={lastPaidTo}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "ToCertificationEndsOn");
                    date && setCertEndsBefore(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </div>

        <div className="datepicker-group" style={{ width: "100%" }}>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Admit Year (After)"
                  value={adminDateFrom}
                  onChange={(date: any) => {
                    date && setConsolidatedDate(date, "FromAdmitDate");
                    date && setAdminDateFrom(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Admit Date (BEFORE)"
                  value={adminDateTo}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "ToAdmitDate");
                    date && setAdminDateTo(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </div>

        <div className="datepicker-group" style={{ width: "100%" }}>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Last Paid Date (AFTER)"
                  value={lastPaidFrom}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "FromLastPaidDate");
                    date && setLastPaidFrom(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="date-input-field-div" style={{ width: "44%" }}>
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Last Paid Date (BEFORE)"
                  value={lastPaidTo}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "ToLastPaidDate");
                    date && setLastPaidTo(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </div>

        {/* <div className="datepicker-group">
          <div className="date-input-field-div">
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local "
                  label="Date Of Birth (From)"
                  value={dateOfBirthFrom}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "FromDOB");
                    date && setDateOfBirthFrom(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div className="date-input-field-div">
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local "
                  label="Date Of Birth (To)"
                  value={dateOfBirthTo}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "ToDOB");
                    date && setDateOfBirthTo(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FMPersonalInfo;
